// Vídeo "como funciona" (Panda) em caixa 3:4. Usado no popup (desktop) e inline
// no lugar do dashboard (mobile). O iframe preenche a caixa; a proporção é fixa.

export function HeroVideo(): React.ReactElement {
  return (
    <div className="relative aspect-[3/4] w-full overflow-hidden rounded-xl">
      <iframe
        src="https://player-vz-da77d45b-cd8.tv.pandavideo.com.br/embed/?v=c259e513-d8b9-4f35-b44f-82f880aeb77f"
        title="Como funciona o Trakd"
        allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture"
        allowFullScreen
        className="absolute inset-0 h-full w-full border-0"
      />
    </div>
  );
}
